import * as React from "react";
import type { SVGProps } from "react";
const SvgTrendingUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M23 6h1a1 1 0 0 0-1-1zm-9.5 9.5-.707.707a1 1 0 0 0 1.414 0zm-5-5 .707-.707a1 1 0 0 0-1.414 0zM.293 17.293a1 1 0 1 0 1.414 1.414zM17 5a1 1 0 1 0 0 2zm5 7a1 1 0 1 0 2 0zm.293-6.707-9.5 9.5 1.414 1.414 9.5-9.5zm-8.086 9.5-5-5-1.414 1.414 5 5zm-6.414-5-7.5 7.5 1.414 1.414 7.5-7.5zM17 7h6V5h-6zm5-1v6h2V6z"
    />
  </svg>
);
export default SvgTrendingUp;
